'use strict';
import axios from "axios";
import Configuration from "@/Common/Configuration";
import Utility from "@/Common/Utility";
import apiService from "@/Common/ApiService";
import MutexService from "@/Common/MutexService";


let AuthorizeService = {

    FuncAuthList: [],

    FuncAuthSet: {},

    RoleId: null,
    RoleIdList: "",



    GetFunctionAuth(functionId) {
        let auth = {
            EditAuth:1
        };

        if (this.Loaded) {
            auth = this.FuncAuthSet[functionId];
        }
        else if (!this.Loading) {
            this.Load();
        }

        return auth;
    },


    Changed: null,

    Loading: false,

    Loaded: false,

    //載入權限
    Load() {
        let roleId;
        let roleIdList;

        this.Loading = true;
         

        roleId = Utility.GetBag("RoleId");
        roleIdList = Utility.GetBag("RoleIdList");

        this.RoleId = roleId;
        this.RoleIdList = 
        this.Loaded = false;

        console.log("AuthorizeService:Load()");

        return apiService.Post(
            "/api/AuthoritySettings/GetFunctionAuthListByRoleId",
            {
                RoleId: roleId,
                RoleIdList: roleIdList,
            }
        ).then(
            function (responseData) {
                let i;
                this.Loading = false;

                this.Loaded = true;

                this.FuncAuthList = responseData.FuncAuthList;

                this.FuncAuthSet = {};

                for (i = 0; i < this.FuncAuthList.length; i++) {
                    let auth = this.FuncAuthList[i];

                    this.FuncAuthSet[auth.FunctionId] = auth;
                }


                Utility.SaveSession("FuncAuthSet", this.FuncAuthSet);


                window["TopVue"].$bus.$emit("AuthChanged");

                return Promise.resolve(this.FuncAuthSet);
            }.bind(this)
        );
    }, //end Load() {

}


export default AuthorizeService;

